import React from 'react';
import { FormSection } from '@/shared/components/ui';
import { ProjectIdentityFields, ProjectMembersField } from './shared';
import type { UseProjectDraftReturn } from '../../hooks/useProjectDraft';

export interface DadosTabProps {
  draft: UseProjectDraftReturn;
}

/**
 * Aba "Dados" — identidade do projeto (nome, cliente, pipeline, líder, cor) +
 * equipe (membros). Campos vivem em componentes compartilhados
 * (`components/form/shared/`) reutilizados pela aba de config do workspace.
 */
export const DadosTab: React.FC<DadosTabProps> = ({ draft }) => {
  const { value } = draft;

  return (
    <div className="max-w-screen-2xl mx-auto px-4 sm:px-6 md:px-8 py-8 space-y-6">
      <FormSection icon="info" title="Dados do projeto" description="Identifique o projeto e onde os tickets serão criados">
        <ProjectIdentityFields
          testIdPrefix="project-form"
          name={value.name}
          onNameChange={(v) => draft.setField('name', v)}
          clientId={value.clientId}
          onClientIdChange={(v) => draft.setField('clientId', v)}
          color={value.color}
          onColorChange={(v) => draft.setField('color', v)}
          pipelineId={value.pipelineId}
          onPipelineChange={(v) => draft.setField('pipelineId', v)}
          leaderId={value.leaderId}
          onLeaderChange={draft.setLeader}
        />
      </FormSection>

      <FormSection icon="users" title="Equipe" description="Membros que acompanham o projeto (o líder já participa)">
        <ProjectMembersField
          testIdPrefix="project-form-members"
          memberIds={value.memberIds}
          leaderId={value.leaderId}
          onChange={draft.setMemberIds}
        />
      </FormSection>
    </div>
  );
};

DadosTab.displayName = 'DadosTab';
